/**
 * resultsCache — centralised sessionStorage wrapper for analysis results.
 *
 * Every component that reads or writes 'aiAnalysisResults' should go through
 * this module so we have a single place for error handling, logging, and
 * (post-conference) compression or storage-tier fallback.
 */

const STORAGE_KEY = 'aiAnalysisResults';

const resultsCache = {
  /**
   * Persist analysis results to sessionStorage.
   * @param {object} data — the results payload (will be JSON-serialised)
   * @returns {boolean} true if the write succeeded
   */
  save(data) {
    try {
      // Clear first to free quota before writing the new payload
      sessionStorage.removeItem(STORAGE_KEY);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      return true;
    } catch (e) {
      console.warn('resultsCache.save: write failed —', e.message);
      return false;
    }
  },

  /**
   * Load analysis results from sessionStorage.
   * @returns {object|null} parsed results or null
   */
  load() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      console.warn('resultsCache.load: read/parse failed —', e.message);
      return null;
    }
  },

  /**
   * Remove cached results (called by Reset Demo).
   */
  clear() {
    sessionStorage.removeItem(STORAGE_KEY);
  },
};

export default resultsCache;
